import { ITesting } from "../types";
import { ACTIONS, TestActions } from "./testActions";

export const testReducer = (state: ITesting, action: TestActions): ITesting => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.ADD_QUESTION:
      return {
        ...state,
        Questions: [...state.Questions, payload.question]
      };

    case ACTIONS.DELETE_QUESTION:
      return {
        ...state,
        Questions: state.Questions.filter(question => question.ID !== payload.id)
      };

    case ACTIONS.CHANGE_QUESTIONS:
      return {
        ...state,
        Questions: state.Questions.map(question => (question.ID === payload.question.ID ? payload.question : question))
      };

    case ACTIONS.CHANGE_MIN_CORRECT_ANSWERS_COUNT:
      return {
        ...state,
        MinCorrectAnswersCount: payload.correctAnswersCount
      };

    case ACTIONS.TOGGLE_QUESTION_FORM_OPEN:
      return {
        ...state,
        IsQuestionFormOpen: payload.isOpen
      };

    case ACTIONS.CHANGE_QUESTIONS_LIST_ORDER:
      return {
        ...state,
        Questions: payload.questions
      };
  }
};
